var sharedVars = {
	fullMonths : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	displayPageNumbers : 5,
	itemsPerPage: 18,
	originalBreakpoint: breakpoint,
	initialMarkup: '',
	initialMarkupFlag: false
}


//Filter Dropdown
var filterContent = {
	config : {
		theData : '',
		clearbtnclick : '',
		pageclick : '',
		pagenum : '',
		fullWide : '',
		displayFeatured : true,
		pageNumbersList : '',
		cancelClicked: false,
		previousLength : 0,
		searchAll : false,
		formatMapping : ['Text','Slides/Video','Slides/Audio','Video','Slides','Audio'],
		nonUsFlag : false,
		contentCutoff: 2011 //removing "type" filter for content generated from prior to this year (including this year) - does not prevent the content from appearing organically or from filtering
	},
	init : function() {
		$("input[name='filterApply']").prop("disabled", true);	
		filterContent.initialSetup();
	},
	initialSetup : function() {
		filterContent.checkForNonUs();
	},
	checkForNonUs : function() {
		$(articleObject.articles).each(function(){
		  if (this.targetCategory == "non-us") {
			filterContent.config.nonUsFlag = true;
		  }
		});
		if (filterContent.config.nonUsFlag === true) {
			$('#filter').addClass('non-us');
			$('.regional-tab-all').addClass('active');
			filterContent.bindRegionalFilters();
			var filterJson = filterContent.setupFilterJson();
			var filterJsonUs = filterContent.setupFilterJsonUs();
			var filterJsonNonUs = filterContent.setupFilterJsonNonUs();
			filterContent.populateFilterOptions(filterJson); //all filter options -- displayed by default
			filterContent.populateFilterOptionsUs(filterJsonUs); //untargted filter options only -- hidden by default
			filterContent.populateFilterOptionsNonUs(filterJsonNonUs); //targeted filter options only -- hidden by default
		}
		else {
			var filterJson = filterContent.setupFilterJson();
			filterContent.populateFilterOptions(filterJson);
		}
	},
	bindRegionalFilters : function(){
		$('.regional-tab').on('click',function(){
			var self = this;
			if ($(this).hasClass('active') !== true) {
				$("input[name='filterApply']").removeClass('enabled');
				$("input[name='filterApply']").prop("disabled", true);					
				$("input[name='filterCancel']").hide();
				$('.animated-checkbox.checked').removeClass('checked')
					.closest('li').find('input[type="checkbox"]').prop('checked',false);

				if (!$('.filterButtons .total-results-refine-box').hasClass('initial-hide')) { //if there's filter results already applied, display the clear box
					 	$("input[name='filterCancel']").show();
				 }
				if ($(self).hasClass('regional-tab-ous')) {
					$("input[name='filterApply']").val('Show all for Global');
				}
				else if ($(self).hasClass('regional-tab-us')) {
					$("input[name='filterApply']").val('Show all for U.S.');
				}
				else {
					$("input[name='filterApply']").val('Show all');
				}
				
				$("input[name='filterApply']").prop("disabled", false);
				$("input[name='filterApply']").addClass('enabled');
				$("input[name='filterApply']").addClass('displayAllFromRegion');
				
				
				$('.animated-checkbox').removeClass('unchecked');
			}
			if ($(this).hasClass('regional-tab-us')) {
				$('#filter').removeClass('only-show-ous-filters');
				$('#filter').addClass('only-show-us-filters');
			}
			else if ($(this).hasClass('regional-tab-ous')) {
				$('#filter').removeClass('only-show-us-filters');
				$('#filter').addClass('only-show-ous-filters');
			}
			else {
				$('#filter').removeClass('only-show-us-filters');
				$('#filter').removeClass('only-show-ous-filters');
			}
			$('.regional-tab.active').removeClass('active');
			$(this).addClass('active');
		});
	},
	setupFilterJson : function() {
		var theJson = {
			conceptList : [{
				conceptId : 1,
				title : ""
			}],
			creditAmountsList : [],
			formatTypeList : [],
			typeList : []
		}
		var creditsList = [];
		var format = [];
		var conceptList = [];
		var activityType = [];
		var greaterThanOne = false;
		$(articleObject.articles).each(function(i){
			if (Number(this.conceptid) > 0) {
				var obj = {};
				obj.conceptId = this.conceptid;
				obj.title = this.concept;
				conceptList.push(obj);
			}

			var objFormat = {};
			objFormat.formatTypeId = this.format;
			objFormat.formatName = filterContent.config.formatMapping[Number(this.format)];
			if (objFormat.formatTypeId !== "") {
				format.push(objFormat);
			}
		
			var yearOfPublication = this.date.split('-')[0];
			if (Number(yearOfPublication) > filterContent.config.contentCutoff) {
				activityType.push(this.typeid);
			}
			
			if (Number(this.credits) > 1) {
					greaterThanOne = true;			
			}
			else {
				creditsList.push(this.credits);
			}
		});
		//sort 
		creditsList.sort();
		
		//remove duplicates
		creditsList = filterContent.uniq(creditsList);
		format = filterContent.uniqFormat(format);
		conceptList = filterContent.uniqConcept(conceptList);
		activityType = filterContent.uniq(activityType);
		
		//add 'greater than 1'
		if (greaterThanOne === true) {
			creditsList.push(">1.0");
		}
		
		//push to config
		theJson.creditAmountsList = creditsList;
		theJson.typeList = activityType;
		theJson.conceptList = conceptList;
		theJson.formatTypeList = format;

		return theJson;
	},
	setupFilterJsonUs : function() {
		var theJson = {
			conceptList : [{
				conceptId : 1,
				title : ""
			}],
			creditAmountsList : [],
			formatTypeList : [],
			typeList : []
		}
		var creditsList = [];
		var format = [];
		var conceptList = [];
		var activityType = [];
		var greaterThanOne = false;
		$(articleObject.articles).each(function(i){
			if (articleObject.articles[i].targetCategory === "global") { //if it is not a targeted region.  We are not including 'us' since the filter option associated with this selection will never display to a 'us' user.
				if (Number(this.conceptid) > 0) {
					var obj = {};
					obj.conceptId = this.conceptid;
					obj.title = this.concept;
					conceptList.push(obj);
				}

				var objFormat = {};
				objFormat.formatTypeId = this.format;
				objFormat.formatName = filterContent.config.formatMapping[Number(this.format)];
				if (objFormat.formatTypeId !== "") {
					format.push(objFormat);
				}
			
				var yearOfPublication = this.date.split('-')[0];
				if (Number(yearOfPublication) > filterContent.config.contentCutoff) {
					activityType.push(this.typeid);
				}
				
				if (Number(this.credits) > 1) {
						greaterThanOne = true;			
				}
				else {
					creditsList.push(this.credits);
				}
			}
		});
		//sort 
		creditsList.sort();
		
		//remove duplicates
		creditsList = filterContent.uniq(creditsList);
		format = filterContent.uniqFormat(format);
		conceptList = filterContent.uniqConcept(conceptList);
		activityType = filterContent.uniq(activityType);
		
		//add 'greater than 1'
		if (greaterThanOne === true) {
			creditsList.push(">1.0");
		}
		
		//push to config
		theJson.creditAmountsList = creditsList;
		theJson.typeList = activityType;
		theJson.conceptList = conceptList;
		theJson.formatTypeList = format;

		return theJson;
	},		
	setupFilterJsonNonUs : function() {
		var theJson = {
			conceptList : [{
				conceptId : 1,
				title : ""
			}],
			creditAmountsList : [],
			formatTypeList : [],
			typeList : []
		}
		var creditsList = [];
		var format = [];
		var conceptList = [];
		var activityType = [];
		var greaterThanOne = false;
		$(articleObject.articles).each(function(i){
			if (articleObject.articles[i].targetCategory !== "global") { //if it is a targeted region. We are not accounting for tagged 'us' content since these filter options will never display for any user receiving content 'us' tagged
				if (Number(this.conceptid) > 0) {
					var obj = {};
					obj.conceptId = this.conceptid;
					obj.title = this.concept;
					conceptList.push(obj);
				}

				var objFormat = {};
				objFormat.formatTypeId = this.format;
				objFormat.formatName = filterContent.config.formatMapping[Number(this.format)];
				if (objFormat.formatTypeId !== "") {
					format.push(objFormat);
				}
			
				var yearOfPublication = this.date.split('-')[0];
				if (Number(yearOfPublication) > filterContent.config.contentCutoff) {
					activityType.push(this.typeid);
				}
				
				if (Number(this.credits) > 1) {
						greaterThanOne = true;			
				}
				else {
					creditsList.push(this.credits);
				}
			}
		});
		//sort 
		creditsList.sort();
		
		//remove duplicates
		creditsList = filterContent.uniq(creditsList);
		format = filterContent.uniqFormat(format);
		conceptList = filterContent.uniqConcept(conceptList);
		activityType = filterContent.uniq(activityType);
		
		//add 'greater than 1'
		if (greaterThanOne === true) {
			creditsList.push(">1.0");
		}
		
		//push to config
		theJson.creditAmountsList = creditsList;
		theJson.typeList = activityType;
		theJson.conceptList = conceptList;
		theJson.formatTypeList = format;

		return theJson;
	},	
	uniq : function(theList) {
		var uniqueKeys = {};
		var uniques = theList.filter(function(obj){
			if(uniqueKeys[obj]) {
				return false;
			}
			uniqueKeys[obj] = true;
				return true;
		});
		return uniques
	},
	uniqConcept : function(concept) {
		var uniqueKeys = {};
		var uniques = concept.filter(function(obj){
			if(uniqueKeys[obj.conceptId]) {
				return false;
			}
			uniqueKeys[obj.conceptId] = true;
				return true;
		});
		return uniques
	},
	uniqFormat : function(format) {
		var uniqueKeys = {};
		var uniques = format.filter(function(obj){
			if(uniqueKeys[obj.formatTypeId]) {
				return false;
			}
			uniqueKeys[obj.formatTypeId] = true;
				return true;
		});
		return uniques
	},	
	populateFilterOptions : function(json) {
		var listOfTopics = '';
		var listOfCredits = '';
		var listOfFormat = '';
		var listOfType = '';

		//sort alphabetic
		json.conceptList.sort(function(a, b){
			if(a['title'] < b['title']){
				return -1;
			}else if(a['title'] > b['title']){
				return 1;
			}
			return 0;
		});
		
		//Create the Markup -- Concept List
		$.each(json.conceptList, function(i, v) {
			if (conceptWhiteList.indexOf(Number(json.conceptList[i].conceptId)) > -1) { 
				listOfTopics += '<li class="mf-heatmap-target all-filter-option"><input type="checkbox" name="topics" value="' + json.conceptList[i].conceptId + '" id="topic' + (i + 1) + '-all">';
				listOfTopics += '<span class="animated-checkbox" tabindex="0"></span><label for="topic' + (i + 1) + '">' + json.conceptList[i].title + '</label></li>';
			}
		});
		//Create the Markup -- Credit Amounts
		$.each(json.creditAmountsList, function(i, v) {
			var tempCredits = (json.creditAmountsList[i].replace(/^(\d+\.\d)$/, "$10"));
			var tempCreditsTime = '';
			if (tempCredits == ">1.0") {
				tempCredits = "&gt;1.00";
				tempCreditsTime = "&gt;60";
				tempCreditsVal = 1.01;
			} else {
				tempCreditsTime = Number(tempCredits) * 60;
				tempCreditsVal = tempCredits;
			}
			if (Number(tempCreditsVal) > 0) {
				listOfCredits += '<li class="mf-heatmap-target all-filter-option"><input type="checkbox" name="credits" value="' + tempCreditsVal + '" id="credit' + (i + 1) + '-all">'
				listOfCredits += '<span class="animated-checkbox" tabindex="0"></span><label for="credit' + (i + 1) + '">' + tempCredits + ' (' + tempCreditsTime + ' min)</label></li>';
			}
		});
		//Create the Markup -- Format
		$.each(json.formatTypeList, function(i, v) {
			listOfFormat += '<li class="mf-heatmap-target all-filter-option"><input type="checkbox" name="format" value="' + json.formatTypeList[i].formatName + '" id="format' + json.formatTypeList[i].formatTypeId + '-all">';
			listOfFormat += '<span class="animated-checkbox" tabindex="0"></span><label for="format' + json.formatTypeList[i].formatTypeId + '">' + json.formatTypeList[i].formatName + '</label></li>';
		});
		//Create the Markup -- Type
		$.each(json.typeList, function(i, v) {
			listOfType += '<li class="mf-heatmap-target all-filter-option"><input type="checkbox" name="type" value="' + json.typeList[i] + '" id="type' + (i + 1) + '-all">';
			listOfType += '<span class="animated-checkbox" tabindex="0"></span><label for="type' + (i + 1) + '">' + json.typeList[i] + '</label></li>';
		});
		
		//Render the markup to the appropriate locations
		$('#filter #topics ul, #filters #topics ul').html(listOfTopics);
		$('#filter #credits ul, #filters #credits ul').html(listOfCredits);
		$('#filter #format ul, #filters #format ul').html(listOfFormat);
		$('#filter #type ul, #filters #type ul').html(listOfType);

		if (filterContent.config.nonUsFlag === false) {
			bindElements.filterMenu.checkboxClick();
			sFilter.bind();
			bindElements.filterMenu.searchTopics();
		}
	},
	populateFilterOptionsUs : function(json) {
		var listOfTopics = '';
		var listOfCredits = '';
		var listOfFormat = '';
		var listOfType = '';

		//sort alphabetic
		json.conceptList.sort(function(a, b){
			if(a['title'] < b['title']){
				return -1;
			}else if(a['title'] > b['title']){
				return 1;
			}
			return 0;
		});
		
		//Create the Markup -- Concept List
		$.each(json.conceptList, function(i, v) {
			if (conceptWhiteList.indexOf(Number(json.conceptList[i].conceptId)) > -1) {
				listOfTopics += '<li class="mf-heatmap-target untargeted-filter-option"><input type="checkbox" name="topics" value="' + json.conceptList[i].conceptId + '" id="topic' + (i + 1) + '-untargeted">';
				listOfTopics += '<span class="animated-checkbox" tabindex="0"></span><label for="topic' + (i + 1) + '">' + json.conceptList[i].title + '</label></li>';
			}
		});
		//Create the Markup -- Credit Amounts
		$.each(json.creditAmountsList, function(i, v) {
			var tempCredits = (json.creditAmountsList[i].replace(/^(\d+\.\d)$/, "$10"));
			var tempCreditsTime = '';
			if (tempCredits == ">1.0") {
				tempCredits = "&gt;1.00";
				tempCreditsTime = "&gt;60";
				tempCreditsVal = 1.01;
			} else {
				tempCreditsTime = Number(tempCredits) * 60;
				tempCreditsVal = tempCredits;
			}
			if (Number(tempCreditsVal) > 0) {
				listOfCredits += '<li class="mf-heatmap-target untargeted-filter-option"><input type="checkbox" name="credits" value="' + tempCreditsVal + '" id="credit' + (i + 1) + '-untargeted">'
				listOfCredits += '<span class="animated-checkbox" tabindex="0"></span><label for="credit' + (i + 1) + '">' + tempCredits + ' (' + tempCreditsTime + ' min)</label></li>';
			}
		});
		//Create the Markup -- Format
		$.each(json.formatTypeList, function(i, v) {
			listOfFormat += '<li class="mf-heatmap-target untargeted-filter-option"><input type="checkbox" name="format" value="' + json.formatTypeList[i].formatName + '" id="format' + json.formatTypeList[i].formatTypeId + '-untargeted">';
			listOfFormat += '<span class="animated-checkbox" tabindex="0"></span><label for="format' + json.formatTypeList[i].formatTypeId + '">' + json.formatTypeList[i].formatName + '</label></li>';
		});
		//Create the Markup -- Type
		$.each(json.typeList, function(i, v) {
			listOfType += '<li class="mf-heatmap-target untargeted-filter-option"><input type="checkbox" name="type" value="' + json.typeList[i] + '" id="type' + (i + 1) + '-untargeted">';
			listOfType += '<span class="animated-checkbox" tabindex="0"></span><label for="type' + (i + 1) + '">' + json.typeList[i] + '</label></li>';
		});
		
		//Render the markup to the appropriate locations
		$('#filter #topics ul, #filters #topics ul').append(listOfTopics);
		$('#filter #credits ul, #filters #credits ul').append(listOfCredits);
		$('#filter #format ul, #filters #format ul').append(listOfFormat);
		$('#filter #type ul, #filters #type ul').append(listOfType);

	},		
	populateFilterOptionsNonUs : function(json) {
		var listOfTopics = '';
		var listOfCredits = '';
		var listOfFormat = '';
		var listOfType = '';

		//sort alphabetic
		json.conceptList.sort(function(a, b){
			if(a['title'] < b['title']){
				return -1;
			}else if(a['title'] > b['title']){
				return 1;
			}
			return 0;
		});
		
		//Create the Markup -- Concept List
		$.each(json.conceptList, function(i, v) {
			if (conceptWhiteList.indexOf(Number(json.conceptList[i].conceptId)) > -1) { 
				listOfTopics += '<li class="mf-heatmap-target targeted-filter-option"><input type="checkbox" name="topics" value="' + json.conceptList[i].conceptId + '" id="topic' + (i + 1) + '-targeted">';
				listOfTopics += '<span class="animated-checkbox" tabindex="0"></span><label for="topic' + (i + 1) + '">' + json.conceptList[i].title + '</label></li>';
			}
		});
		//Create the Markup -- Credit Amounts
		$.each(json.creditAmountsList, function(i, v) {
			var tempCredits = (json.creditAmountsList[i].replace(/^(\d+\.\d)$/, "$10"));
			var tempCreditsTime = '';
			if (tempCredits == ">1.0") {
				tempCredits = "&gt;1.00";
				tempCreditsTime = "&gt;60";
				tempCreditsVal = 1.01;
			} else {
				tempCreditsTime = Number(tempCredits) * 60;
				tempCreditsVal = tempCredits;
			}
			if (Number(tempCreditsVal) > 0) {
				listOfCredits += '<li class="mf-heatmap-target targeted-filter-option"><input type="checkbox" name="credits" value="' + tempCreditsVal + '" id="credit' + (i + 1) + '-targeted">'
				listOfCredits += '<span class="animated-checkbox" tabindex="0"></span><label for="credit' + (i + 1) + '">' + tempCredits + ' (' + tempCreditsTime + ' min)</label></li>';
			}
		});
		//Create the Markup -- Format
		$.each(json.formatTypeList, function(i, v) {
			listOfFormat += '<li class="mf-heatmap-target targeted-filter-option"><input type="checkbox" name="format" value="' + json.formatTypeList[i].formatName + '" id="format' + json.formatTypeList[i].formatTypeId + '-targeted">';
			listOfFormat += '<span class="animated-checkbox" tabindex="0"></span><label for="format' + json.formatTypeList[i].formatTypeId + '">' + json.formatTypeList[i].formatName + '</label></li>';
		});
		//Create the Markup -- Type
		$.each(json.typeList, function(i, v) {
			listOfType += '<li class="mf-heatmap-target targeted-filter-option"><input type="checkbox" name="type" value="' + json.typeList[i] + '" id="type' + (i + 1) + '-targeted">';
			listOfType += '<span class="animated-checkbox" tabindex="0"></span><label for="type' + (i + 1) + '">' + json.typeList[i] + '</label></li>';
		});
		
		//Render the markup to the appropriate locations
		$('#filter #topics ul, #filters #topics ul').append(listOfTopics);
		$('#filter #credits ul, #filters #credits ul').append(listOfCredits);
		$('#filter #format ul, #filters #format ul').append(listOfFormat);
		$('#filter #type ul, #filters #type ul').append(listOfType);


		bindElements.filterMenu.checkboxClick();
		sFilter.bind();
		bindElements.filterMenu.searchTopics();
	},	
	reformatDates : function() {
		$('.reformatted-date').remove();
		$('#activities .card .byline .posting-date').each(function() {
				var dateWithTime = $(this).html().split(' ');
				var thisProgramDate = dateWithTime[0].split('-');
				$(this).closest('.byline').append("<span class='reformatted-date'>, " + sharedVars.fullMonths[thisProgramDate[1] - 1] + " " + thisProgramDate[2] + ", " + thisProgramDate[0] + '</span>')
		});
	},
	masonryLayout : function() {
		columnAdjust.init();
		displayTheCards();
		$(function(){
			autoImgAdjust.init();
		});
	}
}

//Element binding
var bindElements = {
	init : function() {
		bindElements.saveLink();
		bindElements.filterMenu.toggleDisplay();
		bindElements.filterMenu.keyboardCheckSelect();
		bindElements.activityTracker();
		bindElements.featuredTopics();
		bindElements.showMoreOus();
		bindElements.closeFilter();
		bindElements.mobileFiltersMenu();
		bindElements.mobileOnlyLinks();
		bindElements.liveEvents.init();
		bindElements.trackFilter();
	},
	trackFilter : function(){
		$('#filter #refineButton').on('click',function(){
			hpTracking.track('filter');
		});
	},
	tracking : {
		extraWide : function(){
			$('.extra-wide-article li').off('click');
			$('.extra-wide-article li').on('click', function(){
				hpTracking.track('extraWide');
			});
		},
		filter : function() {
		
		}
	},
	liveEvents : {
		init : function(){
			if(qrllog == "1" && location.pathname!= "" && location.pathname != "/" && specialtyKey!== undefined && specialtyKey!==""){
				this.getLiveEvents();
			}
		},
		getLiveEvents: function(){
			var self = this;
			var queryParam ="isAccredited=true";
			specialtyKey.split(',').forEach(function(key){
				queryParam += "&specialty="+key;
			});
			var env = (location.hostname.indexOf('qa') > -1) ? 'qa.' : '';
			var getLiveActivitiesUrl = "http://live-event-sql-service.k8s."+ env +"medscapelive.com/live-events/search?"+queryParam;
			$.ajax({
				type: "GET",
				url: getLiveActivitiesUrl,
				dataType: "json",
				cache: true,
				success: function (response) {
					if(!$.isEmptyObject(response) && response.liveEvents.length>0){
						self.bindLiveEvents(response.liveEvents);
					}
				},
				error: function (data) {
				  console.warn("Home page live events - Get Call Failed : " + data);
				},
				complete: function (){
					self.addToggle();
				}
			});
		},
		bindLiveEvents : function(events){
			var eventsMarkUp='';
			var isUsUser= s_user_origin == "us" ? true : false;
			events.forEach(function(event){
				if(!(isUsUser && event.excludeUsAudience == true)){
					var startDate = new Date(event.startDate).toLocaleDateString("en-US", { weekday: 'short', month: 'long', day: 'numeric', year: 'numeric'});
					var eventLocation = (event.location == null || event.location == '')? "" : "<span class='event-location'>"+ event.location +"</span>";
					eventsMarkUp+= "<div class='cmesitecallout'><span class='event-wrapper'><span class='event-header'>Live Event</span><span class='event-title'><a href='"+ event.registerLink +"' target='_blank'>"+ event.title + "</a></span></span><span class='byline'><span class='event-date'>"+ startDate +"</span>"+eventLocation+"</span><span class='register-link'><a href='"+ event.registerLink +"' target='_blank'>Register Now</a></span></div>";
				}
			});
			$("#eventCalloutsRight .bucketContent.lbuEvents").append(eventsMarkUp);
		},
		addToggle: function(){
			if ($('.live-events .cmesitecallout').length > 0) {
				$('.live-events').addClass('not-empty');
			}
			if ($('.live-events .cmesitecallout').length > 1) {
				$('.live-events .bucketFooter').html('<div class="expandLink"></div>');
				$('#eventCalloutsRight .expandLink').on('click',function(){
					$('#eventCalloutsRight').toggleClass('expanded');
				});
			}
			else {
				$('.live-events').addClass('less-than-two');
			}
		}
	},
	mobileOnlyLinks : function() {
		$('.bp-one-saved, .bp-one-tracker').on('click',function(event){
			var target = this;
			event.preventDefault();
			if (Number(qrllog) !== 1) {
				var targetModal = 'saved';
				if ($(target).hasClass('bp-one-tracker')) {
					targetModal = 'tracker'
				}
				menuItems.loggedOut.displayLoggedOutModal(targetModal);
			}
			else {
				var link = $(this).find('a').attr('href');
				window.location = link;
			}
		});
	},
	mobileFiltersMenu : function() {
		$(document).on('click','.filter-back-button',function(){
			$('.filter-top-section-text').html('Filters');
			$('.js-mobile-selection')
				.removeClass('js-mobile-selection')
				.removeClass('js-mobile-topics')
				.removeClass('js-mobile-credits')
				.removeClass('js-mobile-format')
				.removeClass('js-mobile-type');
		});
		$('#mobile-filter-menu .menu-options').on('click',function(){
			$('.filter-top-section-text').html('<span class="filter-back-button">Back</span>');
			$(this).closest('#filterContent').addClass('js-mobile-selection js-mobile-'+$(this).html().toLowerCase());
		});
	},
	closeFilter : function() {
		$('.close-x').on('click',function(){
			$('#refineButton').toggleClass("closed");
			$('#filterContent').slideToggle("fast");
			$('#modal-bg-layer').remove();
			setTimeout(function(){
			$('.filter-top-section-text').html('Filters');
			$('#filterContent')
				.removeClass('js-mobile-selection')
				.removeClass('js-mobile-topics')
				.removeClass('js-mobile-credits')
				.removeClass('js-mobile-format')
				.removeClass('js-mobile-type');
			},500);			
		});
	},
	featuredTopics : function() {
		$('.viewmore').on('click',function(){
			$('#featuredTopics').toggleClass('expanded');
		});
	},
	activityTracker : function() {
		$('#tracker .morelink').on('click',function(){
			window.location = $(this).find('a').attr('href');
		});
	},
	saveLink : function() {
		$('#activities').on('click','.saveState',function(event){
			menuItems.config.savedActivitiesChanged = true;
			event.preventDefault()
			if (isUserLogged === true) {
				if ($(this).hasClass('saved')) {
					var txnId = Number($(this).attr('id').replace('txn','').replace('-activity',''));
					saveUserActivities.update(txnId);
					$(this).html('<span class="star-blue"></span><br />Save');
					$(this).removeClass('saved');
				}
				else {
					var cardData = getCardData(this);
					
					cardData.creditarray = cardData.creditarray.filter(function(el){
						return el.credits;
					});
					
					$(this).html('<span class="star-blue"></span><br />Saved');
					saveUserActivities.save(cardData, this);
					$(this).addClass('saved');
					/*
					$(this).addClass('saved-flash');
					setTimeout(){funciton(){
					
					
					},2000);
					*/
				}
			}
			else {
				if ($('.login-save-msg').length < 1) {
					var cardTarget = '.card';
					if ($(this).closest('.cards').hasClass('extra-wide-article')) {
						cardTarget = 'li';
					}
					$(this).closest(cardTarget).append('<div class="login-save-msg">Please log in to save activities</div>')
					$('.login-save-msg').css('height','0px').css('opacity',0);
					setTimeout(function(){
						$('.login-save-msg').css('height','20px');
					},100);
					setTimeout(function(){
						$('.login-save-msg').css('opacity',100);
					},200);
					setTimeout(function(){
						$('.login-save-msg').css('height','0px').css('opacity',0);
					},2900);
					setTimeout(function(){
						$('.login-save-msg').remove();
					},3000);
				}
			}
		});
		$('#saved-activities').on('click','.saveState',function(event){
			menuItems.config.savedActivitiesChanged = true;
			event.preventDefault()
			var txnId = Number($(this).attr('id').replace('txn','').replace('-saved',''));
			
			
			saveUserActivities.update(txnId).done(function(){
				menuItems.config.savedActivitiesChanged = true;
				menuItems.loggedIn.displaySaved();
				$('#txn'+ txnId + '-saved').removeClass('saved');
				$('#txn'+ txnId + '-saved').html('<span class="star-blue"></span><br />Save');
				$('#txn'+ txnId + '-saved').attr('id','')
				
				$('#txn'+ txnId + '-activity').removeClass('saved');
				$('#txn'+ txnId + '-activity').html('<span class="star-blue"></span><br />Save');
				$('#txn'+ txnId + '-activity').attr('id','')				
			});			
			

			savedCards.init();
			$('.saved-card').addClass('ready-two');
		});		
	},
	filterMenu : {
		toggleDisplay : function() {
			$('#refineButton').on('click',function(){
				$('.animated-checkbox').removeClass('unchecked');
				if ($(this).hasClass('closed')) {
					hpTracking.track('CMEHP-Fltr');
					openFilterLogic();
				}
				else {
					$('#modal-bg-layer').remove();
				}				
				$(this).toggleClass("closed");
				$('#filterContent').slideToggle("fast");
			});		
		},
		searchTopics : function() {
			$('.refine-topics-search').on('input',function(e){
				$('.no-topic-results').remove();
				$('#topics').addClass('filtering');
				$('.unchecked').removeClass('unchecked');

				if ($(this).val().length < filterContent.config.previousLength) {
					filterContent.config.searchAll = true;
				}

				filterContent.config.previousLength = $(this).val().length;
				var searchString = $(this).val();
				$('#filterContent #topics ul li').each(function(i){
					var self = this;
					if ($(this).is(":visible") || filterContent.config.searchAll === true) {
						var topicString = $(this).find('label').html().toUpperCase();
						if (topicString.indexOf(searchString.toUpperCase()) >= 0) {
							$(self).show();
						}
						else {
							$(self).hide();
						}
					}
				});
				filterContent.config.searchAll = false;
				if ($('#topics ul li:visible').length < 1) {
					$('#topics ul').prepend('<span class="no-topic-results">No results found</span>')
				}
			});
		},
		checkboxClick : function() {
			$('#filter li').on('click', function(e) {
				$("input[name='filterApply']").removeClass('displayAllFromRegion');
				var action = 'add';
				e.stopPropagation();
				e.preventDefault();
				
				$('#topics').removeClass('filtering')
				
				if ($(this).find('input[type="checkbox"]').prop('checked') === true) {
					action = 'remove';
					$(this).find('input[type="checkbox"]').prop('checked' , false)
				}
				else {
					$(this).find('input[type="checkbox"]').prop('checked' , true)
				}
			
				if ($(this).find('.animated-checkbox').hasClass('checked')) {
					$(this).find('.animated-checkbox').removeClass('checked');
					$(this).find('.animated-checkbox').addClass('unchecked');
				}
				else {
					$(this).find('.animated-checkbox').removeClass('unchecked');
					$(this).find('.animated-checkbox').addClass('checked');
				}
			
				if ($("#filter input:checkbox:checked").length > 0 || $('.filtered-selections').length > 0) { //if there's a checkbox selected
					$("input[name='filterApply']").addClass('enabled');
					$("input[name='filterApply']").val('Apply');
					$("input[name='filterApply']").prop("disabled", false);
					$("input[name='filterCancel']").show();
				} 
				else {
					if ($('#refineOptionsSelected').length <= 0 && $('.filtered-selections').length < 1) {	//
						$("input[name='filterApply']").removeClass('enabled');
						$("input[name='filterApply']").prop("disabled", true);					
						$("input[name='filterCancel']").hide();
					}
				}
				var type = $(this).closest('.filterCol').attr('id');
				var param = $(this).closest('li').find('input').val();
			});
		},
		keyboardCheckSelect : function() {
			$("#filterContent form").on('keydown',function(e){
				if(e.keyCode == 32){
					e.preventDefault();
					/*
					$(document.activeElement).addClass('checked');
					*/
				}
			});
		}
	},
	showMoreOus : function() {
		$('.show-more-ous').on('click',function(){
			window.location = $(this).data('link');
		});
	}
}

var animateCards = {
	init : function() {
		$('#activities .dynamic-column-1').eq(0).addClass('ready');
		$('#activities .dynamic-column-2').eq(0).addClass('ready');
		$('#activities .dynamic-column-3').eq(0).addClass('ready');
		setTimeout(function(){
			animateCards.otherCards();
			if (sharedVars.initialMarkupFlag === false) {
				sharedVars.initialMarkup = $('#activities').html(); //Homepage function
				sharedVars.initialMarkupFlag = true;
			}
			$('.ready').removeClass('ready').addClass('ready-two');
		},500);

	},
	otherCards : function() {
		$('.card').addClass('ready')
	},
	waveOut : function() {
		$('.card').each(function(i){
			var id = '#cardOrder' + i;
			setTimeout(function(){
			$(id).removeClass('ready');$(id).removeClass('ready-two');},(50 * i));
		});	
	},
	waveIn : function() {
		$('.card').each(function(i){
			var id = '#cardOrder' + i;
			setTimeout(function(){
				if ($(id).length > 0) {
					if ($(id).html().length > 0) {
						$(id).addClass('ready-two');
					}
				}
			},(50 * i));
		});
	},
	filter : function() {
		$('.primary-card-section .card').each(function(i){
			var id = '#cardOrder' + i;
			setTimeout(function(){
				if ($(id).length > 0) {
					if ($(id).html().length > 0) {
						$(id).addClass('ready-two');
					}
				}
			},(50 * i));
		});
	}
}

var displayVisibleImages = function(){

/*
	var counter = 0;
	$('.card .activityImage img').off('error');
	$('.card .activityImage img').on('error',function(){
		counter++;
		if (counter < 500) {
			$(this).attr('src','//img.'+getDomain()+'medscapestatic.com/pi/global/icons/placeholder.png');
		}
	});
*/
	$('.card .activityImage img').each(function(){
		var cleanPath = $(this).data('urlpath')
		if (cleanPath !== '//img.medscapestatic.com/?interpolation=lanczos-none&resize=300:*')
		$(this).attr('src',cleanPath);
	});
}

var featuredArticles = {
	config : {
		rowDepth: 3,
		extraWide: -1,
		copiedMarkup : ''
	},
	init : function() {
		featuredArticles.config.rowDepth = Number($('.full-width-row-location').data('row'));
		$(function(){
			featuredArticles.findExtraWide();
		});
	},
	findExtraWide : function() {
		$(articleObject.articles).each(function(i){
				if (Number(this.homespecrank) === 2) { // tagged low..
					if (Number (this.homespecfeatured) === 1) { // tagged featured..
						if (featuredArticles.config.extraWide === -1) { //only take the most recently tagged article
							featuredArticles.config.extraWide = i;
							featuredArticles.copyArticles();
						}
					}
				}
		});
	},
	copyArticles  : function() {
		featuredArticles.config.copiedMarkup += $('.primary-card-section').html()
		featuredArticles.updateMarkup();
	},
	setWideMarkup : function() {
			var wideArt = articleObject.articles[featuredArticles.config.extraWide];
			var newImgPath = sFilter.updateImgPath(wideArt.thumbnail);
			var e = '<span class="meta-info">';
			e += '<span class="meta-info-concept-name">'+wideArt.concept+'</span>';
			e += '<span class="meta-info-concept-id">'+wideArt.conceptid+'</span>';
			e += '<span class="meta-info-target-category">'+wideArt.targetCategory+'</span>';			
			e += '<span class="meta-info-credit-type">'
			
			$(wideArt.creditarray).each(function(){
					e+= '<span class="credit-type">'+wideArt.credittype+'</span>';
					e+= '<span class="credit-value">'+wideArt.credits+'</span>';
			});			
			
			e+= '</span>';
			e += '<span class="meta-info-credits">'+wideArt.credits+'</span>';
			e += '<span class="meta-info-activity-type">'+wideArt.typeid+'</span>';
			e += '<span class="meta-info-format">'+wideArt.format+'</span>';
			e += '<span class="meta-info-full-width-ad">'+wideArt.featuredstatus+'</span>';
			e += '</span>';
			e += '<div class="activityTitle"><a href="'+wideArt.url+'" class="title">'+wideArt.title+'</a></div>';
			e += '<div class="byline">'+wideArt.specialty+'<span class="posting-date">'+wideArt.date+'</span></div>';
			e += '<div class="teaser">'+wideArt.summary+'</div>';
			e += '<div class="activityImage">';
			e += '<a href="'+wideArt.url+'">';
			e += '<img src="'+newImgPath+'" class="featimg" border="0" alt=""></a></div>';
			e += '<div class="activityData">'+sFilter.theAvailCredits(wideArt);
			e += '<span class="activity-data-divider div-three"></span>'
			e += '<div class="saveState"><span class="star-blue"></span><br>Save</div>';
			e += '</div>';
			return e;
	},
	updateMarkup: function() {
		if (featuredArticles.config.extraWide !== -1) { //if an extrawide featured article exists...
			if (featuredArticles.config.rowDepth === 1)
				$('#activities').addClass('extra-wide-featured-row-one');
			if (featuredArticles.config.rowDepth === 2)
				$('#activities').addClass('extra-wide-featured-row-two');
			else if (featuredArticles.config.rowDepth === 3)
				$('#activities').addClass('extra-wide-featured-row-three');
		}

		
			
		var theNewMarkup = "<ul class='cards masonry pre-extra-wide'>"+featuredArticles.config.copiedMarkup+"</ul>"
		theNewMarkup += "<ul class='cards masonry extra-wide-article'><li>" + featuredArticles.setWideMarkup() + "</li></ul>";
		
		
		$('.primary-card-section').before(theNewMarkup);
		removeDuplicates();
		bindElements.tracking.extraWide();
		
		$('.extra-wide-article li').each(function(){
			var self = this;
			var credits = $(this).find('.length .credits-number').text();
			if (credits <= 0 || isNaN(credits)) {
				$(self).addClass('hidden-data');
			}
		});
		
		
		$('.cards.extra-wide-article .activityImage').clone().appendTo('.cards.extra-wide-article .activityTitle');
		
		$('cards.extra-wide-article .reformatted-date').remove();
		$('.extra-wide-article .byline .posting-date').each(function() {
				var dateWithTime = $(this).html().split(' ');
				var thisProgramDate = dateWithTime[0].split('-');
				$(this).closest('.byline').append("<span class='reformatted-date'>, " + sharedVars.fullMonths[thisProgramDate[1] - 1] + " " + thisProgramDate[2] + ", " + thisProgramDate[0] + '</span>')
		});
		
		clickableCards();
		displayVisibleImages();
		
		
	}
}




var sFilter = {
	config : {
		filterBy : {
			concept : [],
			credits : [],
			format : [],
			type : []
		},
		filteredList : [[],[],[],[]],
		displayList : [],
		filteredArray : [],
		formatMap : ['Text','Slides/Video','Slides/Audio','Video','Slides','Audio'],
		featuredArray: [],
		ousArray: [],
		count: 0
	},
	init : function(page) {
			resetEmptyCardMarkup();
			columnAdjust.init(); //Masonry function
			$('.hidden-data').removeClass('hidden-data');
			$('#modal-bg-layer').remove();
			$('.no-results-found').remove();
			$('.ous-title').hide();
			setTimeout(function(){
			$('.filter-top-section-text').html('Filters');
			$('#filterContent')
				.removeClass('js-mobile-selection')
				.removeClass('js-mobile-topics')
				.removeClass('js-mobile-credits')
				.removeClass('js-mobile-format')
				.removeClass('js-mobile-type');
			},500);
			pagination.config.currentPage = 1;
			sFilter.removeFeatured();
			sFilter.removeOus();
			sFilter.config.filteredArray = [];
			sFilter.pushAndSortSelections();			
			sFilter.filterContent();
			sFilter.updateMarkup(page);
			clickableCards();
			sFilter.clearConfig();
			sFilter.hideMenu();
			autoImgAdjust.init()
			filterContent.reformatDates();
			sFilter.updateTotalCount();
			getActivities.checkComplete();
			totalResultsFromJsp = sFilter.config.filteredArray.length;
			pagination.filterInit();
			sFilter.hideEmptyCreditInfo();
			savedCards.star();
	},
	pageFilter : function(page) {
		resetEmptyCardMarkup();
		columnAdjust.init(); //Masonry function
		$('.hidden-data').removeClass('hidden-data');
		$('.no-results-found').remove();
		$('.ous-title').hide();
		if (page == '1' && $("#filter input:checkbox:checked").length < 1) {
			cleanSlateReset();
		}
		else {
			sFilter.removeFeatured();
			sFilter.removeOus();
			sFilter.config.filteredArray = [];	
			sFilter.pushAndSortPageSelections();
			sFilter.filterContent();
			sFilter.updateMarkup(page, true);
			clickableCards();
			sFilter.clearConfig();
			sFilter.hideMenu();
			autoImgAdjust.init();
			filterContent.reformatDates();
			getActivities.checkComplete();
			totalResultsFromJsp = sFilter.config.filteredArray.length;
			sFilter.hideEmptyCreditInfo();
		}
		savedCards.star();
	},
	bind : function() {
		$("input[name='filterApply']").on('click',function(){
			if ($("input[name='filterApply']").hasClass('displayAllFromRegion')) {
				$('displayAllFromRegion').removeClass('displayAllFromRegion');
				if ($('.regional-tab-all').hasClass('active')) {
					cleanSlateReset();
				}
				else if ($('.regional-tab-us').hasClass('active')) {
					$('#filter .bucketFooter').html('');
					sFilter.track();
					sFilter.init('1','us');				
				}
				else if ($('.regional-tab-ous').hasClass('active')) {
					$('#filter .bucketFooter').html('');
					sFilter.track();
					sFilter.init('1','ous');
				}
				$("input[name='filterApply']").val('Apply');
			}
			else if ($("#filter input:checkbox:checked").length > 0) {
				if ($(this).hasClass('enabled')) {
					$('#filter .bucketFooter').html('');
					sFilter.track();
					sFilter.init('1');
				}
			}
			else if ($(this).hasClass('enabled')) {
				cleanSlateReset();
			}
		});

		$("input[name='filterCancel']").on("click", function() {
			cleanSlateReset();
		});
		
		$('#filter').on('click','.filtered-selections',function(){
			if ($('.filtered-selections').length > 1) {
				var filteredId = $(this).data('filterid');
				$('#filterContent').find('input:checked').each(function(){
					if (String($(this).val()) == filteredId) {
						$(this).prop('checked',false);
						$(this).closest('li').find('.animated-checkbox').removeClass('checked');
					}
				});
				$('#filter .bucketFooter').html('');			
				sFilter.init('1');
			}
			else {
				cleanSlateReset();
			}
		});
		
	},
	removeFeatured : function() {
		$('.jsp-featured').each(function(){
			sFilter.config.featuredArray.push($(this).html());
			$(this).remove();
		});
		$('.extra-wide-featured-row-one').removeClass('extra-wide-featured-row-one');
		$('.extra-wide-featured-row-two').removeClass('extra-wide-featured-row-two');
		$('.extra-wide-featured-row-three').removeClass('extra-wide-featured-row-three');
		$('.pre-extra-wide').remove();
		$('.extra-wide-article').remove();
	},
	removeOus : function() {
		$('.ous-ul').each(function(){
			sFilter.config.ousArray.push($(this).html());
			$(this).remove();
		});	
		$('.ous-section').hide();
	},
	pushAndSortSelections : function() {

	
		// push the value of each checked box into the appropriate array in the filterBy object
		$('#filterContent').find('input:checked').each(function(){
			var value = String($(this).val());
			var displayValue = String($(this).closest('li').find('label').text());
			var target = $(this).attr('name');		
			switch (target)
			{
			   case "topics":
					sFilter.config.filterBy.concept.push(String(value));
					sFilter.filterSelectionButtons(String(displayValue), String(value));
					break;
					
			   case "credits":
					sFilter.config.filterBy.credits.push(Number(value));
					var displayValueNum = Number(value) + " Credits";
					if (Number(value) > 1)
						displayValueNum = "> 1.0 Credits"
					sFilter.filterSelectionButtons(displayValueNum, Number(value));
					break;
					
			   case "format":
					sFilter.config.filterBy.format.push(value);
					sFilter.filterSelectionButtons(String(displayValue), value);
					break;

			   case "type":
					sFilter.config.filterBy.type.push(value);
					sFilter.filterSelectionButtons(value, value);
					break;
			}
		});
		
		
		
	},
	pushAndSortPageSelections : function() {
		// push the value of each checked box into the appropriate array in the filterBy object
		$('#filterContent').find('input:checked').each(function(){
			var value = String($(this).val());
			var displayValue = String($(this).closest('li').find('label').text());
			var target = $(this).attr('name');		
			switch (target)
			{
			   case "topics":
					sFilter.config.filterBy.concept.push(String(value));
					break;
					
			   case "credits":
					sFilter.config.filterBy.credits.push(Number(value));
					break;
					
			   case "format":
					sFilter.config.filterBy.format.push(value);
					break;

			   case "type":
					sFilter.config.filterBy.type.push(value);
					break;
			}
		});
	},	
	filterContent : function() {		
		//reduce article array to targeted region
		if (filterContent.config.nonUsFlag === true) { // don't bother traversing the dom for the selection if the user isn't ous
			if ($('#filter').hasClass('only-show-us-filters')) {
				var tempArray = [];
				$(articleObject.articles).each(function(i){
					if (articleObject.articles[i].targetCategory === "global") {
						tempArray.push(articleObject.articles[i]);
					}
				});
				sFilter.config.filteredArray = tempArray;
			}
			else if ($('#filter').hasClass('only-show-ous-filters')) {
				var tempArray = [];
				$(articleObject.articles).each(function(i){
					if (articleObject.articles[i].targetCategory === "non-us") {
						tempArray.push(articleObject.articles[i]);
					}
				});
				sFilter.config.filteredArray = tempArray;			
			}
			else {
				sFilter.config.filteredArray = articleObject.articles; //reset the initial array
			}
		}
		else {
			sFilter.config.filteredArray = articleObject.articles; //reset the initial array
		}
		
		
		if (sFilter.config.filterBy.concept.length > 0) {
			sFilter.config.filteredArray = sFilter.config.filteredArray.filter(function(item){
				return (sFilter.config.filterBy.concept.indexOf(item.conceptid) !== -1)
			});
		}
		if (sFilter.config.filterBy.credits.length > 0) {
			sFilter.config.filteredArray = sFilter.config.filteredArray.filter(function(item){
				var tempCred = item.credits;
				if (item.credits > 1)
					tempCred = 1.01;
				return (sFilter.config.filterBy.credits.indexOf(Number(tempCred)) !== -1)
			});
		}
		if (sFilter.config.filterBy.format.length > 0) {
			sFilter.config.filteredArray = sFilter.config.filteredArray.filter(function(item){
				formatId = Number(item.format);
				return (sFilter.config.filterBy.format.indexOf(sFilter.config.formatMap[formatId]) !== -1)				
			});
		}
		if (sFilter.config.filterBy.type.length > 0) {
			sFilter.config.filteredArray = sFilter.config.filteredArray.filter(function(item){
				return (sFilter.config.filterBy.type.indexOf(item.typeid) !== -1)				
			});
		}
	},
	updateImgPath : function(img){
		var newImgPath = img.replace('professional_assets/medscape/images/','//img.'+getDomain()+'medscapestatic.com/');

		if (newImgPath.length < 1)
			newImgPath = '//img.'+getDomain()+'medscapestatic.com/pi/global/icons/placeholder.png'

			
		return newImgPath
	},
	updateMarkup : function(page, isPageClick) {
		$('.cards .card').removeClass('hidden').addClass('displayed');
		if (sFilter.config.filteredArray.length < 18) {
			var countStart = sFilter.config.filteredArray.length;
			for (i = 0; i < 18 - countStart; i++) { 
				$('#cardOrder'+(countStart + i)).addClass('hidden').removeClass('displayed');
			}
		}
		
		var startAt = (pagination.config.currentPage  - 1) * 18
		var endAt = pagination.config.currentPage * 18;
		var idCounter = 0;

		$('.ready').removeClass('ready');
		$('.ready-two').removeClass('ready-two');
		
		if (isPageClick === true) {
			var theOffset = $("#filter").offset().top;
			theOffset = theOffset - 45;
			$('html, body').animate({
				scrollTop: theOffset
			}, 0);
		}
		if (sFilter.config.filteredArray.length === 0) {
			sFilter.zeroContent();
		}
		$(sFilter.config.filteredArray).each(function(i){
			if (i >= startAt && i < endAt) {
				var  newImgPath = '';
				if (this.thumbnail.length === 0) {
					newImgPath = sFilter.updateImgPath(this.thumbnail);
				}
				else {				
					newImgPath = sFilter.updateImgPath(this.thumbnail) + '?interpolation=lanczos-none&amp;resize=300:*';
				}
				if (newImgPath.indexOf("medscapestatic.com") === -1) { //if relative path, add domain...
					newImgPath = "//img.medscapestatic.com" + newImgPath;
				}
			
				var e = '<span class="meta-info">';
				e += '<span class="meta-info-concept-name">'+this.concept+'</span>';
				e += '<span class="meta-info-concept-id">'+this.conceptid+'</span>';
				e += '<span class="meta-info-target-category">'+this.targetCategory+'</span>';
				e += '<span class="meta-info-credit-type">';
				
				$(this.creditarray).each(function(){
						e+= '<span class="credit-type">'+this.credittype+'</span>';
						e+= '<span class="credit-value">'+this.credits+'</span>';
				});
				
				e+= '</span>';
				e += '<span class="meta-info-credit-type">'+this.credittype+'</span>';
				e += '<span class="meta-info-credits">'+this.credits+'</span>';
				e += '<span class="meta-info-activity-type">'+this.typeid+'</span>';
				e += '<span class="meta-info-format">'+this.format+'</span>';
				e += '<span class="meta-info-full-width-ad">'+this.featuredstatus+'</span>';
				e += '</span>';
				e += '<div class="activityTitle"><a href="'+this.url+'" class="title">'+this.title+'</a></div>';
				e += '<div class="byline">'+this.specialty+'<span class="posting-date">'+this.date+'</span></div>';
				e += '<div class="teaser">'+this.summary+'</div>';
				e += '<div class="activityImage">';
				e += '<a href="'+this.url+'">';
				e += '<img src="'+newImgPath+'" class="featimg" border="0" alt=""></a></div>';
				e += '<div class="activityData">'+sFilter.theAvailCredits(this);
				e += '<span class="activity-data-divider div-three"></span>';
				e += '<div class="saveState"><span class="star-blue"></span><br>Save</div>';
				e += '</div>';
					
				$('#cardOrder'+idCounter).html(e);	
				$('#cardOrder0').addClass('ready-two');
				idCounter++
			}
		});
		setTimeout(function(){
			animateCards.filter();
			savedCards.init();
		},0);
	},
	theAvailCredits : function(card) {
		var mocCounter = 0;
		var metaCreditArray = $(card.creditarray);
		var creditsMarkup = '';
		
		var creditTypesArray = [];
		var creditsArray = [];
		$(card.creditarray).each(function(){
			var self = this;
			$.each(Object.keys(this),function(i){
				if (this == "credittype") {
					var creditType = Number(Object.values(self)[i]);
					creditTypesArray.push(creditType);
				}
				else if (this == "credits") {
					var credits = Number(Object.values(self)[i]);
					creditsArray.push(credits);
				}
				else {
					//fallback to "credits" if misconfigured data
					var credits = Number(Object.values(self)[i]);
					creditsArray.push(credits);
				}
			});

		});

		var highestLength = (Math.max.apply(Math, creditsArray)) * 60;
		var mocCheck = creditTypesArray.indexOf(9);
		var cmeCheck = creditTypesArray.indexOf(1);
		
		//check each of the other 6 CE credit types.. if any exist, save the index value to target the credits in the next function. Only save 1 CE type.
		var ceCheck = creditTypesArray.indexOf(2)
		if (ceCheck < 0)
			ceCheck = creditTypesArray.indexOf(3);
		if (ceCheck < 0)
			ceCheck = creditTypesArray.indexOf(4);
		if (ceCheck < 0)
			ceCheck = creditTypesArray.indexOf(5);
		if (ceCheck < 0)
			ceCheck = creditTypesArray.indexOf(7);
		if (ceCheck < 0)
			ceCheck = creditTypesArray.indexOf(8);
		if (ceCheck < 0)
			ceCheck = creditTypesArray.indexOf(10);
		
		//format whole numbers
		if (creditsArray[mocCheck] % 1 === 0)
			creditsArray[mocCheck] = Number(creditsArray[mocCheck]).toFixed(1);
		if (creditsArray[ceCheck] % 1 === 0)
			creditsArray[ceCheck] = Number(creditsArray[ceCheck]).toFixed(1);
		if (creditsArray[cmeCheck] % 1 === 0)
			creditsArray[cmeCheck] = Number(creditsArray[cmeCheck]).toFixed(1);
		
		if (mocCheck > -1) { //if abim moc
			creditsMarkup += '<span class="abim-credits"><span class="credits-number">'+creditsArray[mocCheck]+'</span>ABIM MOC</span>';
			mocCounter++;
		}
		if (ceCheck > -1) { //if ce
			if (cmeCheck > -1) { //if ce & cme
				if (mocCounter > 0) {
					creditsMarkup += '<span class="activity-data-divider div-one"></span>';
					creditsMarkup += '<span class="primary-credits"><span class="credits-number">'+creditsArray[cmeCheck]+'</span>CME/CE</span>'
				}
				else {
					creditsMarkup += '<span class="primary-credits"><span class="credits-number">'+creditsArray[cmeCheck]+'</span>CME/CE</span>'				
				}
			}
			else { //if just ce
				if (mocCounter > 0) {
					creditsMarkup += '<span class="activity-data-divider div-one"></span>';
				}
				creditsMarkup += '<span class="primary-credits"><span class="credits-number">'+creditsArray[ceCheck]+'</span>CE</span>'
				mocCounter++;
			}
		}
		else if (cmeCheck > -1) { //if cme (when there isn't ce)
			if (mocCounter > 0) {
				creditsMarkup += '<span class="activity-data-divider div-one"></span>';
			}		
			creditsMarkup += '<span class="primary-credits"><span class="credits-number">'+creditsArray[cmeCheck]+'</span>CME</span>'
			mocCounter++;
		}
		else {
			creditsMarkup += '<span class="primary-credits"><span class="credits-number">'+creditsArray[0]+'</span>Credits</span>'
		}

		creditsMarkup += '<span class="activity-data-divider div-two"></span>';
		creditsMarkup += '<span class="length"><span class="credits-number">'+highestLength+'</span>MIN</span>'
		return creditsMarkup
	},
	clearConfig : function() {
		sFilter.config.filterBy.concept = [];
		sFilter.config.filterBy.credits = [];
		sFilter.config.filterBy.format = [];
		sFilter.config.filterBy.type = [];
		sFilter.config.filteredList = [[],[],[],[]];
		sFilter.config.displayList = [];
	},
	hideMenu : function() {
		if (!$('#refineButton').hasClass('closed')) {
			$('#filterContent').slideToggle("fast");
			$('#refineButton').addClass('closed');
		}
	},
	updateTotalCount : function() {
		$('.total-results-refine-box').removeClass('initial-hide').html(sFilter.config.filteredArray.length + ' Results');
	},
	filterSelectionButtons : function(display, filterid) {
		var filters = "<div class='filtered-selections' data-filterid='"+filterid+"'>"+display+"</div>";
		var addOn = $('#filter .bucketFooter').html() + filters;
		$('#filter .bucketFooter').html(addOn);
	},
	zeroContent : function() {
		$('.full-width-row-location').after('<span class="no-results-found">No results found.</span>');
	},
	hideEmptyCreditInfo : function() {
		$('.card').each(function(){
			var self = this;
			var credits = $(this).find('.length .credits-number').text();
			if (credits <= 0 || isNaN(credits)) {
				$(this).find("span[class$='-credits']").css("display", "none");
				$(this).find(".activity-data-divider").css("display", "none");
				$(this).find(".length").css("display", "none");
			}
		});
	},
	track : function(){
		var trackingStr = '';
		$('#topics ul li input:checked').each(function(){
			trackingStr += $(this).val();
			trackingStr += ",";
		});
		trackingStr += ';';
		$('#credits ul li input:checked').each(function(){
			trackingStr += $(this).val();
			trackingStr += ",";
		});
		trackingStr += ';';
		$('#format ul li input:checked').each(function(){
			var splitStr = $(this).attr('id').split('format');
			trackingStr += splitStr[1];
			trackingStr += ",";
		});
		trackingStr += ';';
		$('#type ul li input:checked').each(function(){
			var typeVal = $(this).val().toLowerCase();
			switch (typeVal) {
				case "clinical case":
					trackingStr += 'cc'
					break;	

				case "journal article":
					trackingStr += 'ja'
					break;	
					
				case "roundtable":
					trackingStr += 'rt'
					break;	

				case "clinical brief":
					trackingStr += 'cb'
					break;	

				case "commentary":
					trackingStr += 'cm'
					break;	

				case "clinical review":
					trackingStr += 'cr'
					break;	

				case "slide/lecture presentation":
					trackingStr += 'sl'
					break;	

				default: 
					trackingStr += typeVal;
			}
			trackingStr += ",";
		});
		var trackingStr = trackingStr.replace(/,;/g, ";") // Remove the last comma of each first 3 groups 
		if (trackingStr[trackingStr.length - 1] === ",") {
			trackingStr = trackingStr.slice(0, -1); //Remove the last comma of the fourth group
		}
		wmdPageLink('filter-'+trackingStr);
	}
}

var pagination = {
	config : {
		pages: 0,
		offset: 0,
		itemCount: 18,
		currentPage: 1,
		theMarkup : ''
	},
	init : function() {
		pagination.getFirstPageOffset();
		pagination.getPageCount();
		pagination.setupMarkup();
		pagination.displayMarkup();
		pagination.bind();
	},
	filterInit : function() {
		pagination.config.pages = 0;
		pagination.config.currentPage = 1;
		pagination.config.theMarkup = '';
		pagination.getPageCount();
		pagination.setupMarkup();
		pagination.displayMarkup();
		pagination.bind();		
	},
	getFirstPageOffset : function() {
		pagination.config.offset = $('.jsp-featured').length;
	},
	getPageCount : function() {
		pagination.config.pages = Math.ceil(totalResultsFromJsp / pagination.config.itemCount);
	},	
	setupMarkup : function() {
		var markup = '';
		for (i = 0; i < pagination.config.pages; i++) { 
			if (i === pagination.config.currentPage-1) {
				markup += '<li class="paginationNum activePage">'+Number(i+1)+'</li>';
			}
			else {
				markup += '<li class="paginationNum"><a href="javascript:void(0)">'+Number(i +1)+'</a></li>'
			}
		}
		pagination.config.theMarkup = markup;
	},
	displayMarkup : function() {
		$('.paginationNum').remove();
		$('.pageBack').after(pagination.config.theMarkup);
		
		$('.pageBack').addClass('page-hidden');
		$('.pageForward').addClass('page-hidden');
		$('.paginationNum').addClass('page-hidden');
		
		if (pagination.config.currentPage === 1) { //first page
			if (pagination.config.currentPage === pagination.config.pages) { //if only one page
				$('.pageBack').addClass('page-hidden');
				$('.pageForward').addClass('page-hidden');
				$('.paginationNum').addClass('page-hidden');
			}
			else {
				$('.pageBack').addClass('page-hidden');
				$('.pageForward').removeClass('page-hidden');
				$('.paginationNum').eq(0).removeClass('page-hidden');
				$('.paginationNum').eq(1).removeClass('page-hidden');
				$('.paginationNum').eq(2).removeClass('page-hidden');
				$('.paginationNum').eq(3).removeClass('page-hidden');
				$('.paginationNum').eq(4).removeClass('page-hidden');
			}
		}
		else if (pagination.config.currentPage === 2) { //second page
			$('.pageBack').removeClass('page-hidden');
			if (pagination.config.currentPage === pagination.config.pages) {
				$('.pageForward').addClass('page-hidden');
			}
			else {
				$('.pageForward').removeClass('page-hidden');
			}
			$('.paginationNum').eq(0).removeClass('page-hidden');
			$('.paginationNum').eq(1).removeClass('page-hidden');
			$('.paginationNum').eq(2).removeClass('page-hidden');
			$('.paginationNum').eq(3).removeClass('page-hidden');
			$('.paginationNum').eq(4).removeClass('page-hidden');
		}
		else if (pagination.config.currentPage === pagination.config.pages - 1) { //second to last page
			var e = pagination.config.currentPage;
			$('.pageBack').removeClass('page-hidden');
			$('.pageForward').removeClass('page-hidden');
			$('.paginationNum').eq(e).removeClass('page-hidden');
			$('.paginationNum').eq(e-1).removeClass('page-hidden');
			$('.paginationNum').eq(e-2).removeClass('page-hidden');
			$('.paginationNum').eq(e-3).removeClass('page-hidden');
			$('.paginationNum').eq(e-4).removeClass('page-hidden');			
		}		
		else if (pagination.config.currentPage === pagination.config.pages) { //last page
			var e = pagination.config.currentPage;
			$('.pageBack').removeClass('page-hidden');
			$('.pageForward').addClass('page-hidden');
			$('.paginationNum').eq(e-1).removeClass('page-hidden');
			$('.paginationNum').eq(e-2).removeClass('page-hidden');
			$('.paginationNum').eq(e-3).removeClass('page-hidden');
			$('.paginationNum').eq(e-4).removeClass('page-hidden');				
			$('.paginationNum').eq(e-5).removeClass('page-hidden');
		}
		else {
			var e = pagination.config.currentPage;
			$('.pageBack').removeClass('page-hidden');
			$('.pageForward').removeClass('page-hidden');
			$('.paginationNum').eq(e-3).removeClass('page-hidden');
			$('.paginationNum').eq(e-2).removeClass('page-hidden');
			$('.paginationNum').eq(e-1).removeClass('page-hidden');
			$('.paginationNum').eq(e).removeClass('page-hidden');				
			$('.paginationNum').eq(e+1).removeClass('page-hidden');
		}
	},
	bind : function() {
		$('.paginationNum').on('click',function() {
			var pagenum = Number($(this).text());
			pagination.config.currentPage = pagenum;
			sFilter.pageFilter(pagenum);
			pagination.init();
		});		
	},
	bindOne : function() {
		$('.pageBack').on('click',function() {
			pagination.config.currentPage--;
			sFilter.pageFilter(pagination.config.currentPage);
			pagination.init();
		});	
		$('.pageForward').on('click',function() {
			pagination.config.currentPage++;
			sFilter.pageFilter(pagination.config.currentPage);
			pagination.init();
		});			
	}
};

var resetEmptyCardMarkup = function() {
	//the reset adjusts with columns 
	var emptyMarkupString = '';
	for (i = 0; i < 18; i++) {
		emptyMarkupString += '<li class="card" id="cardOrder'+i+'"></li>';
	}
	$('.cards.masonry.primary-card-section').html(emptyMarkupString);
}

var removeDuplicates = function() {
	/* //logic moved to homepage jsp for the initial duplicate check.  This function is now used only for the extra-wide duplicate check
		var featuredArray = [];
		$('.jsp-featured:visible').each(function(){
			featuredArray.push($(this).find('.activityTitle a').attr('href'));
		});
		$('.extra-wide-article:visible').each(function(){
			featuredArray.push($(this).find('.activityTitle a').attr('href'));
		});
		$('.cards .card:visible').each(function(){
			var self = this;
			if (!$(this).hasClass('jsp-featured')) {
				if (!$(this).hasClass('ous-card')) {
					var theArticleId = $(this).find('.activityTitle a').attr('href');
					if (featuredArray.indexOf(theArticleId) > -1) {
						$(self).addClass('duplicate-article');
						$(self).remove();
					}
				}
			}
		});
	*/
	var extraWidePath = [];
	$('.extra-wide-article').each(function(){
		extraWidePath.push($(this).find('.activityTitle a').attr('href'));
	});
	if (extraWidePath.length > 0) {
		$("li[id^='cardOrder']").each(function(i){
			var self = this;
			var theNonFeaturedPath = $(this).find('.activityTitle a').attr('href');
			if (extraWidePath.indexOf(theNonFeaturedPath) > -1) { // if the current article already exists as an extra-wide featured item, hide it
				$(self).hide();
			}
		});
	}



}

var ousCheck = function() {
	if ($('.ous-ul li').length < 1) {
		$('.ous-section').remove()
	}
	if ($('.ous-ul li').length < 6) {
		$('.show-more-ous').css('visibility','hidden');
	}	
};

var loggedOutCheck = function() {
	if (isUserLogged === false) {// if the user is logged out
			$('.logged-out-tracker').remove();
			$('.ous-title').hide();
			$('.cmeCredits').hide();
			var loginLink = "https://login."+getDomain()+"medscape.com/login/sso/getlogin";
			var cleanLink = loginLink.replace('staging.','');
			$('.cmeCredits').after('<div class="logged-out-tracker"><a href="'+cleanLink+'">Log in</a> to keep track of your credits.</div>');
			$('#tracker .morelink').remove();
			
			$('.hp-anon').addClass('logged-out');
			
	}
};

function shuffleFeatured() {
	var array = [];
	$('#featuredTopics ul li').each(function(){
		(array).push(this);
	});


  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  $('#featuredTopics ul').html(array);
}


var featuredTopicsCheck = function() {

	shuffleFeatured();

	if ($('#featuredTopics ul li').length < 1) {
		$('#featuredTopics').hide();
	}

	if ($('#featuredTopics ul li').length > 6) {
		$('#featuredTopics .bucketFooter').removeClass('hidden-section');
	}
	else {
		$('#featuredTopics ul li:last-child').addClass('last-featured-topic');
	}
	jQuery('#featuredTopics ul li a[data-order]').sort(sort_featured).parent().prependTo('#featuredTopics ul');
	function sort_featured(a, b) {
	  return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
	}
}

var openFilterLogic = function() {
	$('#modal-bg-layer').remove();
	$('body').before('<span id="modal-bg-layer"></span>');

	/*	
	if (breakpoint === 2) {
		setTimeout(function(){
			var newMaxHeight = 500
			if ($('#credits').height() + $('#format').height() + $('#type').height() < 500)
				newMaxHeight = $('#credits').height() + $('#format').height() + $('#type').height();
			$('#edu .bucket#filter .filterCols .filterCol#topics ul').css('height',newMaxHeight);
		},500);
	
	}
	
	if (breakpoint === 1) {
		var filterHeight = $(window).height();
		$('#filterContent').height($(window).height());
	}
	*/
}

var initialCreditCheck = function() {
	$('.cards .card .meta-info-credit-type').each(function(){
		var  newMarkup = '';
		var creditTypeArray = [];
		var creditAmtArray = [];
		var creditArray = []; //build an array from the jsp markup so we can re-use the same function used on filter
		var parentObj = {"creditarray" : ""}
		$(this).find('.credit-type').each(function(){
			creditTypeArray.push($(this).text());			
		});
		$(this).find('.credit-value').each(function(i){
			var theObj = {"credittype":"", "credits":""};
			theObj.credits = $(this).text()
			theObj.credittype = creditTypeArray[i];
			creditArray.push(theObj)
		});

		parentObj.creditarray = creditArray;
		newMarkup += sFilter.theAvailCredits(parentObj);

		newMarkup += '<span class="activity-data-divider div-three"></span>';
		newMarkup += '<div class="saveState"><span class="star-blue"></span><br>Save</div>';
		$(this).closest('.card').find('.activityData').html(newMarkup);

	});
	
}
var brokenImageCheck = function() {
	$('img').each(function(){
		if ($(this).attr('src').indexOf(".com/?") > -1) {
			$(this).attr('src','//img.'+getDomain()+'medscapestatic.com/pi/global/icons/placeholder.png');
		}		
	});

}

var resetSavedActivities = function() {
	$('.saveState.saved').attr('id','');
	$('.saveState.saved').removeClass('saved');
	savedCards.star();
}

var clickableCards = function(){
	//removing clickable cards for the saved feature -- EB 8.15.17
	/*
	$('.card').off('click');
	$('.cards.masonry .activityTitle .title').each(function(){
		var path = $(this).attr('href');
		$(this).closest('.card').on('click',function(){
			window.location.href = path;
		});
	});
	*/
}

var maxFilterWindowHeight = function(){
	$('#filterContent').css('height','100px');
	$('#edu .bucket#filter .filterCols .filterCol#topics ul').css('height','300px');



}

var cleanSlateReset = function() {
	$("input[name='filterApply']").val('Apply');
	$('#filterContent').find('input[type="checkbox"]').prop('checked' , false)
	$('.animated-checkbox.checked').removeClass('checked');
	$("input[name='filterApply']").removeClass('enabled');
	$("input[name='filterApply']").prop("disabled", true);
	$("input[name='filterCancel']").hide();
	$('.lock-button').removeClass('lock-button');
	$('#filter .bucketFooter').html('');
	sFilter.init('1');

	if (featuredArticles.config.extraWide !== -1) {
		if (featuredArticles.config.rowDepth === 1)
			$('#activities').addClass('extra-wide-featured-row-one');	
		if (featuredArticles.config.rowDepth === 2)
			$('#activities').addClass('extra-wide-featured-row-two');
		else if (featuredArticles.config.rowDepth === 3)
			$('#activities').addClass('extra-wide-featured-row-three');
	}
	
	$('.total-results-refine-box').addClass('initial-hide');
	$('#activities').html(sharedVars.initialMarkup);
	$('.ready').removeClass('ready');
	animateCards.init();
	pagination.init();
	bindElements.showMoreOus();
	columnAdjust.reSort.config.cleanSlate = true; // Masonry Variable
	columnAdjust.reSort.init(); //Masonry Function
	getActivities.checkComplete(); // getActivities Function
	resetSavedActivities();
}



function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

var breakpointChange = debounce(function() {
	if (sharedVars.originalBreakpoint !== breakpoint) {
		columnAdjust.reSort.init(); // masonry
		sharedVars.originalBreakpoint = breakpoint;
	}
}, 250);

window.addEventListener('resize', breakpointChange);

var getSaved = {
	config : {
		obj: ''
	},
	init : function() {
		getSaved.config.obj = getUserActivities.get();
	},
	markup : function() {
	
	}
}


var getCardData = function(self){
	var cardTarget = '.card';
	if ($(self).closest('.cards').hasClass('extra-wide-article')) {
		cardTarget = 'li';
	}


	var summary = $(self).closest(cardTarget).find('.teaser').text();
	var title = $(self).closest(cardTarget).find('.activityTitle').text();
	var specialty = $(self).closest(cardTarget).find('.byline').html().split('<')[0];
	var credits = $(self).closest(cardTarget).find('.meta-info-credits').text();
	var date = $(self).closest(cardTarget).find('.posting-date').text();
	var url = $(self).closest(cardTarget).find('.activityTitle').find('a').attr('href');
	var thumb = $(self).closest(cardTarget).find('.activityImage').find('img').attr('src');
	
	//credits array
	var tempArr = [];
	$(self).closest(cardTarget).find('.meta-info-credit-type').find('.credit-type').each(function(i){
		var newObj = {"credittype":"","credits":""}
		newObj.credittype = $(this).text();
		tempArr.push(newObj);
	});
	$(self).closest(cardTarget).find('.meta-info-credit-type').find('.credit-value').each(function(i){
		tempArr[i].credits = $(this).text();
	});
	
	//if no meta-info is available on the card, target the dom elements
	if (tempArr.length < 1) {
		var noMetaObj = {"credittype":"","credits":""}
		noMetaObj.credittype = "Credits";
		noMetaObj.credits = $(self).closest(cardTarget).find('.activityData .credits-number').html();
		tempArr.push(noMetaObj);
	}	
	
	var articleId = url.split('/');
	articleId = articleId[articleId.length-1];

	var payload = {
		"summary" : summary,
		"title" : title,
		"specialty" : specialty,
		"creditarray" : tempArr,
		"credittype" : 'CME / ABIM MOC / CE',
		"credits" : credits,
		"date" : date,
		"url" : url,
		"thumbnail" : thumb,
		"article" : articleId
	}
	return payload
}

var savedCards = {
	config : {
		loggedIn : false,
		count : 0,
		initialSavedCopy : '',
		initCount : 0
	},
	init : function() {
		if (savedCards.config.initCount < 1) {
			savedCards.config.initialSavedCopy = $('.saved-activities-center').html();
			savedCards.config.initCount++;
		}
		savedCards.loggedStatus(); //checks logged-in status
		if (savedCards.config.loggedIn === true) {
			getUserActivities.get(3);
		}
		else {
			$('.saved-activities-center').html(savedCards.config.initialSavedCopy);
			savedCardsHomepage.display();
		}
	},
	loggedStatus : function() {
		if (Number(qrllog) == 1) {
			savedCards.config.loggedIn = true;
		}
	},
	star : function() {
		if (savedCards.config.loggedIn === true) {
			var listOfSaved;
			$('.cards .card .activityTitle a').each(function(){
				var theArtId = $(this).attr('href').replace('/viewarticle/','');
				listOfSaved += theArtId + ',';
			});
			var cleanedList = listOfSaved.substring(0, listOfSaved.length-1);
			getUserActivities.star(cleanedList);
		}
	}
}

var savedCardsHomepage = {
	cardMarkup : function(obj) {
		var cardMarkup;
		if (savedCards.config.count < 1) {
			cardMarkup = "<span class='saved-activities-cta'>Save activities for later...</span>You haven't saved any activities just yet but once you do, they will show here so that you can easily access them whenever you're ready.";
		}
		else {
			cardMarkup = '<ul class="cards masonry saved-ul">';
			var cardOne;
			var cardTwo;
			var cardThree;
			$(obj.data).each(function(i){
				var txnId = this.userTxnId;
				var  newImgPath = '';
				var jsonData = this.jsonData;
				if (typeof jsonData.thumbnail !== 'undefined') {
					if (jsonData.thumbnail.length === 0) {
						newImgPath = sFilter.updateImgPath(jsonData.thumbnail);
					}
					else {				
						newImgPath = sFilter.updateImgPath(jsonData.thumbnail) + '?interpolation=lanczos-none&amp;resize=300:*';
						newImgPath = newImgPath.replace('http:','');
					}
				}
			
				var e = '<span class="meta-info">';
				e += '<span class="meta-info-concept-name">'+jsonData.concept+'</span>';
				e += '<span class="meta-info-concept-id">'+jsonData.conceptid+'</span>';
				e += '<span class="meta-info-target-category">'+jsonData.targetCategory+'</span>';				
				e += '<span class="meta-info-credit-type">';
				e+= '</span>';
				e += '<span class="meta-info-credit-type">'+jsonData.credittype+'</span>';
				e += '<span class="meta-info-credits">'+jsonData.credits+'</span>';
				e += '<span class="meta-info-activity-type">'+jsonData.typeid+'</span>';
				e += '<span class="meta-info-format">'+jsonData.format+'</span>';
				e += '<span class="meta-info-full-width-ad">'+jsonData.featuredstatus+'</span>';
				e += '</span>';
				e += '<div class="activityTitle"><a href="'+jsonData.url+'" class="title">'+jsonData.title+'</a></div>';
				e += '<div class="byline">'+jsonData.specialty+'<span class="posting-date">'+jsonData.date+'</span></div>';
				e += '<div class="teaser">'+jsonData.summary+'</div>';
				e += '<div class="activityImage">';
				e += '<a href="'+jsonData.url+'">';
				e += '<img src="'+newImgPath+'" class="featimg" border="0" alt=""></a></div>';
				e += '<div class="activityData">'+sFilter.theAvailCredits(jsonData);
				e += '<span class="activity-data-divider div-three"></span>';
				e += '<div class="saveState saved" id="txn'+txnId+'-saved"><span class="star-blue"></span><br>Saved</div>';
				e += '</div>';
					

				if (i === 0) {
					cardOne = e;
				}
				else if (i === 1) {
					cardTwo = e;
				}
				else if (i === 2) {
					cardThree = e;
				}

				

			});

			if ($('body').hasClass('column-count-1')) {
				cardMarkup += '<div class="dynamic-column-1-header">';
				cardMarkup += '<li class="card saved-card dynamic-column-1">'+cardOne+'</li>';
				if (typeof cardTwo !== "undefined") {
					cardMarkup += '<li class="card saved-card dynamic-column-1">'+cardTwo+'</li>';
				}
				if (typeof cardThree !== "undefined") {
					cardMarkup += '<li class="card saved-card dynamic-column-1">'+cardThree+'</li>';
				}
				cardMarkup+= '</div>';
				cardMarkup += '<div class="dynamic-column-2-header"></div>';
				cardMarkup += '<div class="dynamic-column-3-header"></div>';				
			}
			else if ($('body').hasClass('column-count-2')) {
				cardMarkup += '<div class="dynamic-column-1-header">';
				cardMarkup += '<li class="card saved-card dynamic-column-1">'+cardOne+'</li>';
				if (typeof cardThree !== "undefined") {
					cardMarkup += '<li class="card saved-card dynamic-column-1">'+cardThree+'</li>';				
				}
				cardMarkup+= '</div>';
				cardMarkup += '<div class="dynamic-column-2-header">';
				if (typeof cardTwo !== "undefined") {
					cardMarkup += '<li class="card saved-card dynamic-column-2">'+cardTwo+'</li>';
				}
				cardMarkup+= '</div>';
				cardMarkup += '<div class="dynamic-column-3-header"></div>';
				
			}
			else if ($('body').hasClass('column-count-3')) {			
				cardMarkup += '<div class="dynamic-column-1-header">';
				cardMarkup += '<li class="card saved-card dynamic-column-1">'+cardOne+'</li>';			
				cardMarkup+= '</div>';
				cardMarkup += '<div class="dynamic-column-2-header">';
				if (typeof cardTwo !== "undefined") {
					cardMarkup += '<li class="card saved-card dynamic-column-2">'+cardTwo+'</li>';
				}
				cardMarkup+= '</div>';
				cardMarkup += '<div class="dynamic-column-3-header">';
				if (typeof cardThree !== "undefined") {
					cardMarkup += '<li class="card saved-card dynamic-column-3">'+cardThree+'</li>';
				}
				cardMarkup+= '</div>';
			}
			
			
			cardMarkup += '</ul>'
		}

		savedCardsHomepage.updateContainer(cardMarkup);
		$('.saved-card').addClass('ready-two');
			
	},
	updateContainer : function(cardMarkup) {
		$('.saved-activities-center').html(cardMarkup);
		savedCardsHomepage.reformatDates();
		savedCardsHomepage.display();
	},
	display : function(){
		$('#saved-activities').addClass('active');
		savedCardsHomepage.viewMore();
		$('.saved-card').each(function(){
			var self = this;
			var credits = $(this).find('.length .credits-number').text();
			if (credits <= 0 || isNaN(credits)) {
				$(self).find("span[class$='-credits']").css("display", "none");
				$(self).find(".activity-data-divider").css("display", "none");
				$(self).find(".length").css("display", "none");
			}
		  });
	},
	viewMore : function(){
		var newMarkup;
		if (savedCards.config.count > 3 && savedCards.config.count > 0) {
			newMarkup = '<a href="/sites/saved">View All ('+savedCards.config.count+') <span class="view-all-arrow"></span>'
		}
		else if (savedCards.config.count < 1) {
			newMarkup = '';
		}
		else {
			newMarkup = '';
		}		
		$('.saved-activities-number').html(newMarkup);
	},
	reformatDates : function() {
		$('#saved-activities .reformatted-date').remove();
		$('#saved-activities .posting-date').each(function() {
				var dateWithTime = $(this).html().split(' ');
				var thisProgramDate = dateWithTime[0].split('-');
				$(this).closest('.byline').append("<span class='reformatted-date'>, " + sharedVars.fullMonths[thisProgramDate[1] - 1] + " " + thisProgramDate[2] + ", " + thisProgramDate[0] + '</span>')
		});
	}	
}

var hpTracking = {
	track : function(value) {
		switch (value) {
			case "extraWide":
				wmdTrack('CMEHP-Triple');
				break;	

			case "filter":
				wmdPageLink('CMEHP-Fltr');
				break;
		}
	}
}

var hoistLiveEventLink = function() {
	$('.cmesitecallout .register-link a').each(function(){
		var link = $(this).attr('href');
		var theHtml = $(this).closest('.cmesitecallout').find('.event-wrapper .event-title').html();
		var theNewHtml = '<a href="'+link+'">'+theHtml+'</a>';
		$(this).closest('.cmesitecallout').find('.event-wrapper .event-title').html(theNewHtml);
	});
}

var checkOusDividers = function() {
	$('.jsp-ous-featured').each(function(){
		$(this).find('.div-three').remove();
		$(this).find('.length').after('<span class="activity-data-divider div-three"></span>');
	});
}

var setCMESearch = function() {
	$('#searchdbvalue').val('3');
}

var updateRegionFilterText = function() {
	$('.regional-tab-ous').after($('.regional-tab-us'))
	$('.regional-tab-ous').html('Global');

}

//On Document Ready
$(function(){
	updateRegionFilterText();
	bindElements.init();
	filterContent.init();
	animateCards.init();
	pagination.init();
	pagination.bindOne();
	featuredTopicsCheck();
	brokenImageCheck();
	hoistLiveEventLink();
	checkOusDividers();
	loggedOutCheck();
    setCMESearch();
});